import type { GameEvent } from "@/types"

export const samiEvents: Record<string, GameEvent> = {
    "dlg-sm-typhon": {
        id: "dlg-sm-typhon",
        type: "dialog",
        dialogues: [
            {
                speaker: "map.speaker.typhon",
                expression: "normal",
                side: "left",
                text: "map.dialog.smTyphon.d1",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "normal",
                side: "right",
                text: "map.dialog.smTyphon.d2",
            },
            {
                speaker: "map.speaker.typhon",
                expression: "normal",
                side: "left",
                text: "map.dialog.smTyphon.d3",
            },
            {
                speaker: "map.speaker.typhon",
                expression: "normal",
                side: "left",
                text: "map.dialog.smTyphon.d4",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "rconfused",
                side: "right",
                text: "map.dialog.smTyphon.d5",
            },
            {
                speaker: "map.speaker.typhon",
                expression: "normal",
                side: "left",
                text: "map.dialog.smTyphon.d6",
            },
            {
                speaker: "map.speaker.typhon",
                expression: "normal",
                side: "left",
                text: "map.dialog.smTyphon.d7",
            },
            {
                speaker: "map.speaker.amiya",
                expression: "smile",
                side: "right",
                text: "map.dialog.smTyphon.d8",
            },
            {
                speaker: "map.speaker.typhon",
                expression: "normal",
                side: "left",
                text: "map.dialog.smTyphon.d9",
            },
            {
                speaker: "map.speaker.typhon",
                expression: "normal",
                side: "left",
                text: "map.dialog.smTyphon.d10",
            },
        ],
        choices: [],
    },

    "dlg-sm-santalla": {
        id: "dlg-sm-santalla",
        type: "dialog",
        dialogues: [
            {
                speaker: "map.speaker.santalla",
                expression: "normal",
                side: "left",
                text: "map.dialog.smSantalla.d1",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "normal",
                side: "right",
                text: "map.dialog.smSantalla.d2",
            },
            {
                speaker: "map.speaker.santalla",
                expression: "normal",
                side: "left",
                text: "map.dialog.smSantalla.d3",
            },
            {
                speaker: "map.speaker.savage",
                side: "right",
                text: "map.dialog.smSantalla.d4",
            },
            {
                speaker: "map.speaker.santalla",
                expression: "normal",
                side: "left",
                text: "map.dialog.smSantalla.d5",
            },
            {
                speaker: "map.speaker.santalla",
                expression: "normal",
                side: "left",
                text: "map.dialog.smSantalla.d6",
            },
            {
                speaker: "map.speaker.santalla",
                expression: "normal",
                side: "left",
                text: "map.dialog.smSantalla.d7",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "normal",
                side: "right",
                text: "map.dialog.smSantalla.d8",
            },
        ],
        choices: [],
    },

    "evt-sm-01": {
        id: "evt-sm-01",
        type: "event",
        description: "map.event.sm01.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.sm01.c1",
                resultText: "map.event.sm01.c1r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.savage",
                        text: "map.event.sm01.c1d",
                    },
                ],
            },
        ],
    },

    "evt-sm-02": {
        id: "evt-sm-02",
        type: "event",
        description: "map.event.sm02.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.sm02.c1",
                resultText: "map.event.sm02.c1r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.amiya",
                        expression: "smile",
                        text: "map.event.sm02.cd",
                    },
                ],
            },
            {
                id: "c2",
                text: "map.event.sm02.c2",
                resultText: "map.event.sm02.c2r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.amiya",
                        expression: "smile",
                        text: "map.event.sm02.cd",
                    },
                ],
            },
        ],
    },

    "evt-sm-03": {
        id: "evt-sm-03",
        type: "event",
        image: require("@/assets/imgs/gallery/CG/cg-sami-3.png"),
        description: "map.event.sm03.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.sm03.c1",
                resultText: "map.event.sm03.c1r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.magallan",
                        expression: "smile",
                        text: "map.event.sm03.cd",
                    },
                ],
            },
            {
                id: "c2",
                text: "map.event.sm03.c2",
                resultText: "map.event.sm03.c2r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.magallan",
                        expression: "smile",
                        text: "map.event.sm03.cd",
                    },
                ],
            },
        ],
        unlockGalleryId: "gal-sm-01",
    },

    "evt-sm-04": {
        id: "evt-sm-04",
        type: "event",
        image: require("@/assets/imgs/gallery/CG/cg-sami-4.png"),
        description: "map.event.sm04.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.sm04.c1",
                resultText: "map.event.sm04.c1r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.amiya",
                        expression: "smile",
                        text: "map.event.sm04.cd",
                    },
                ],
            },
            {
                id: "c2",
                text: "map.event.sm04.c2",
                resultText: "map.event.sm04.c2r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.amiya",
                        expression: "smile",
                        text: "map.event.sm04.cd",
                    },
                ],
            },
        ],
        unlockGalleryId: "gal-sm-02",
    },

    "evt-sm-05": {
        id: "evt-sm-05",
        type: "event",
        image: require("@/assets/imgs/gallery/CG/cg-sami-5.png"),
        description: "map.event.sm05.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.sm05.c1",
                resultText: "map.event.sm05.c1r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.santalla",
                        expression: "normal",
                        text: "map.event.sm05.cd",
                    },
                ],
            },
            {
                id: "c2",
                text: "map.event.sm05.c2",
                resultText: "map.event.sm05.c2r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.santalla",
                        expression: "normal",
                        text: "map.event.sm05.cd",
                    },
                ],
            },
        ],
        unlockGalleryId: "gal-sm-03",
    },
}
